// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cf3bd247","147":"48198676","362":"f91c9b73","574":"6c85020d","807":"521f78d8","899":"431d50ab","900":"815301c4","952":"48b2d655","996":"3b8c4e52"}[chunkId] + ".chunk.js";
};